<template>
  <div>
    <button id="show-modal" @click="showModal = true" class="icon-btn__with-text">
      <div class="hover-text">
        ხარვეზის შეტყობინება
      </div>
      <i class="fas fa-exclamation-triangle warning-color-hover"></i>
    </button>
    <transition name="modal">
      <div class="text-left modal-mask" v-if="showModal">
        <div class="modal-wrapper" @click="layerClick" id="modalCheck">
          <div class="modal-container">
            <div class="modal-header">
              <h4>ხარვეზის შეტყობინება</h4>
            </div>

            <div class="modal-body" v-if="!showForm">
              მადლობას გიხდით თქვენი კომენტარი მიღებულია
            </div>

            <div class="modal-body" v-else>
              <div class="form-group">
                <label for>კითხვა</label>
                <v-select
                  name="questionId"
                  label="question"
                  :reduce="(item) => item.id"
                  :options="questionsOption"
                  v-model="questionId"
                />
              </div>

              <div class="form-group">
                <label for>სათაური</label>
                <input type="text" class="form-control" v-model="problem.title" />
              </div>
              <div class="form-group">
                <label for>აღწერა</label>
                <textarea type="text" class="form-control" v-model="problem.body"></textarea>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-sm btn-success" v-if="showForm" @click="store">
                გაგზავნა
              </button>
              <button class="btn btn-sm btn-success" v-else @click="showForm = true">
                თავიდან გაგზავნა
              </button>

              <button class="btn btn-sm btn-danger" @click="closeModal">
                დახურვა
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { stripTags } from '../../helpers/strip-tags';

export default {
  props: ['question_id', 'test', 'questions'],
  components: { vSelect },
  data() {
    return {
      problem: {
        title: '',
        body: '',
      },
      questionId: this.question_id,
      showForm: true,
      showModal: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.showForm = true;
    },
    store() {
      if (this.problem.title == '' && this.problem.body == '') {
        return alert('გთხოვთ შეავსოთ მოცემული ველი');
      }
      this.problem.question_id = this.questionId;
      this.problem.subject_id = this.test.subject_id;
      this.problem.test_id = this.test.id;
      axios
        .post('/test/problems', this.problem)
        .then((res) => {
          console.log(res);
          this.showForm = false;
          this.problem = {};
        })
        .catch((errors) => console.log(errors));
    },
    layerClick(e) {
      if (e.target.id == 'modalCheck') this.showModal = false;
    },
  },
  watch: {
    question_id: function () {
      this.questionId = this.question_id;
    },
  },
  computed: {
    questionsOption: function () {
      return this.questions.map((q, i) => {
        let text = stripTags(q.question);
        text = text.length > 60 ? text.substring(0, 60) + '...' : text;
        return {
          ...q,
          question: `${i + 1}. ${text}`,
        };
      });
    },
  },
};
</script>
